class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));

    // New scroll-related properties
    this.scrollThreshold = 100;
    this.lastScrollPosition = 0;
    this.handleScroll = this.handleScroll.bind(this);

    // New click outside listener
    this.handleClickOutside = this.handleClickOutside.bind(this);

    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('click', this.handleClickOutside);

    // Listen for header events
    const headerMenu = document.querySelector('header-menu');
    if (headerMenu) {
      headerMenu.addEventListener('headerHidden', this.hidePanel.bind(this));
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('click', this.handleClickOutside);

    const headerMenu = document.querySelector('header-menu');
    if (headerMenu) {
      headerMenu.removeEventListener('headerHidden', this.hidePanel.bind(this));
    }
  }

  toggleSelector(event) {
    event.preventDefault();
    this.elements.button.setAttribute(
      'aria-expanded',
      (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
    );
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.classList.toggle('active');
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
    this.elements.button.classList.remove('active');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }

  handleScroll() {
    const currentScrollPosition = window.scrollY;

    if (currentScrollPosition > this.scrollThreshold) {
      this.classList.add('scrolled');

      if (currentScrollPosition > this.lastScrollPosition) {
        // Scrolling down
        this.classList.add('form-hidden');
      } else {
        // Scrolling up
        this.classList.remove('form-hidden');
      }
    } else {
      this.classList.remove('scrolled');
      this.classList.remove('form-hidden');
    }

    this.lastScrollPosition = currentScrollPosition;
  }
}

customElements.define('localization-form', LocalizationForm);
